import {Directive, ElementRef, AfterViewInit, NgZone} from '@angular/core';


declare var jQuery: any;
declare var foundation: any;

@Directive({
  selector: '[foundation]',
  standalone: true
})

export class FoundationInit implements AfterViewInit{
  constructor(private el: ElementRef, private zone: NgZone) {
  }

  ngAfterViewInit() {
      this.zone.runOutsideAngular(() => {
          const elem = jQuery(this.el.nativeElement);
          if (!elem.attr('data-foundinit')) {
              elem.attr('data-foundinit', 'true');
              elem.foundation();
          }
      });
  }
}
